// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__bcCik","field":"styles_field__3gyk8","fieldCol":"styles_fieldCol__1a6aj","diffCol":"styles_diffCol__7ppI0","diff":"styles_diff__37K4Z"};